import React from 'react';
import { UsurpAd } from 'site-modules/shared/components/native-ad/srp-ad/usurp-ad';
import { EasListingUsurpAd } from 'site-modules/shared/components/native-ad/eas-listing-usurp-ad/eas-listing-usurp-ad';

// MINIMUM_CARDS and first position values should be equals (ADS-5322)
export const MINIMUM_CARDS = 4;

export const UsurpAdsConfig = {
  [MINIMUM_CARDS]: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-4">
          <UsurpAd dco {...adProps} />
        </AdTargetingPrefetch>
      );
    },
  },
  8: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-7">
          <UsurpAd position={'2'} {...adProps} />
        </AdTargetingPrefetch>
      );
    },
  },
  12: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-11">
          <UsurpAd position={'3'} {...adProps} />
        </AdTargetingPrefetch>
      );
    },
  },
  16: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-15">
          <UsurpAd position={'4'} {...adProps} />
        </AdTargetingPrefetch>
      );
    },
  },
  default: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="srp-retention-7-default">
          <UsurpAd {...adProps} />
        </AdTargetingPrefetch>
      );
    },
  },
  last: {
    component(AdTargetingPrefetch, adProps) {
      return (
        <AdTargetingPrefetch key="eas-listing-usurp-ad">
          <EasListingUsurpAd {...adProps} />
        </AdTargetingPrefetch>
      );
    },
  },
};
